import { Flex, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";

const RoleInfoBox = () => {
  return (
    <Flex
      flexDirection="column"
      gap={8}
      style={{
        padding: SPACING.MEDIUM,
        backgroundColor: Colors.Neutral200,
        marginBottom: SPACING.MEDIUM,
      }}
    >
      <Flex flexDirection="row" gap={4}>
        <Text variant="strong-md" style={{ color: Colors.Neutral700 }}>
          Owners
        </Text>
        <Text variant="regular-md">
          are individuals or entities who own 25% or more of the equity interests of the entity.
        </Text>
      </Flex>
      <Flex flexDirection="row" gap={4}>
        <Text variant="strong-md" style={{ color: Colors.Neutral700 }}>
          Controllers
        </Text>
        <Text variant="regular-md">
          are individuals or entities with significant responsibility for managing the entity.
          Minimum of 1 required.
        </Text>
      </Flex>
      <Flex flexDirection="row" gap={4}>
        <Text variant="regular-md">
          If this profile is neither an owner or a controller, do not select either role.
        </Text>
      </Flex>
    </Flex>
  );
};

export default RoleInfoBox;
